export const SCREEN_TABLET = 991
